import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { IConfigurationData, IPageQueryParams } from 'src/app/domain/interfaces/configuration-data.interface';
import { CCGTakerService } from 'src/app/domain/services/ccg-taker.service';
import { DownloadService } from 'src/app/domain/services/download.service';
import { ProposalService } from 'src/app/domain/services/proposals.service';
import { ClauseService } from 'src/app/domain/services/clause.service';
import { AverageMixService } from 'src/app/domain/services/average-mix.service';
import { UserService } from 'src/app/domain/services/user.service';
import { DialogComponent } from '../dialog/dialog.component';
import { LoadComponent } from 'src/app/ui/load/load.component';
import { TakerService } from 'src/app/domain/services/taker.service';
import { IProposalRequestByCode, IImprimirProposalRequest, IEmitirApoliceProposalRequest, IProposalRequestByCodeI4pro} from "src/app/domain/interfaces/proposal.interface";
import { IProfileClaimResponse } from 'src/app/domain/interfaces/access-profile.interface';
import { LiberacaoPropostaTomadorService } from 'src/app/domain/services/parametros/liberacao-proposta-tomador/liberacao-proposta-tomador.service';
import { TabelaPropostaEnum, TipoDePropostaEnum } from 'src/app/domain/enums/enums';
import { EnviromentsService } from "src/app/domain/services/enviroments.service";
import { UtilsService } from 'src/app/domain/services/utils.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {

  actions: string[];
  profileClaimResponse: IProfileClaimResponse[] = [];
  @Input() response: IConfigurationData;
  @Input() dataSource = new MatTableDataSource();
  @Output() eventButton = new EventEmitter<any>(true);
  @Output() secondEventButton = new EventEmitter<any>(true);
  @Output() checkCCGTomador = new EventEmitter();
  proposalByCodeRequest: IProposalRequestByCode;
  ImprimirProposalRequest: IImprimirProposalRequest;
  EmitirApoliceProposalRequest: IEmitirApoliceProposalRequest;
  ProposalRequestByCodeI4pro: IProposalRequestByCodeI4pro;
  habilitaImprimirApolice = false;

  loadEnviromentsObj:any = [];

  constructor(
    private router: Router,
    private ccgTomadorService: CCGTakerService,
    private userService: UserService,
    private downloadService: DownloadService,
    private propososalService: ProposalService,
    private enviromentsService: EnviromentsService,
    private clauseService: ClauseService,
    private averageMixService: AverageMixService,
    private dialog: MatDialog,
    private liberacaoPropostaTomadorService: LiberacaoPropostaTomadorService,
    private utilsService: UtilsService
  ) { }

  ngOnInit() {
    this.actions = localStorage.getItem('profileClaim').split(',');
    this.profileClaimResponse = this.utilsService.returnlocalStorageProposta();
    this.loadEnviroments();
  }

  goToNavigate(page: string, id: number, pageParams?: IPageQueryParams[]) {
    if(pageParams != undefined && pageParams.length > 0) {
      let p = {};
      pageParams.forEach(parm => { p[parm.name] = parm.value; });
      this.router.navigate([`${page}/${id}`], { queryParams: p });
    }
    else{
      this.router.navigate([`${page}/${id}`]);
    }
  }

  goToNavigateUser(page: string, id: number, pageParams: any) {
    this.router.navigate([`${page}/${id}`], {queryParams: { listType: pageParams.userTypeId}});
  }

  emitCheckCCG(page: string, id: number, pageParams?: IPageQueryParams): void{
    this.checkCCGTomador.emit({page: page, id: id, pageParams: pageParams});
  }

  toTransmit(legalPersonId: number): void {
    const loadRef = this.dialog.open(LoadComponent, {
      panelClass: "custom-modalbox",
      disableClose: true,
    });

    this.ccgTomadorService.sendDocument(legalPersonId).subscribe((res :any) => {
      this.showModal('Sucesso', res.data.message, null, 'ENTENDI');
      loadRef.close()
    },(error) => {
      loadRef.close()
    });
  }

  printDocument(legalPersonId: number): void {
    this.ccgTomadorService.printDocument(legalPersonId)
      .subscribe((response: any) => {
        this.downloadService.file(
          response,
          `application/pdf`,
          `Contrato`,
          `pdf`
        );
      });
  }

  loadEnviroments(){
    this.enviromentsService.GeAlltEnviroments()
      .subscribe((res) => {
        this.loadEnviromentsObj = res;
      });
  }

  resendPassword(id: string): void {
    const loadRef = this.dialog.open(LoadComponent, {
      panelClass: 'custom-modalbox',
      disableClose: true
    });

    this.userService.resendPassword(id).subscribe((sucess) => {
      loadRef.close();
      this.showModal('Sucesso', 'Email enviado com sucesso!', null, 'ENTENDI');
    },
      (erro) => {
        loadRef.close();
        this.showModal('Erro', 'Houve um erro ao reenviar o e-mail!', null, 'ENTENDI');
      });
  }

  duplicateProposal(page, id): void {
    this.propososalService
      .postProposalDuplicate(id)
      .subscribe((res) => {
        if (res.value != null) {
          this.goToNavigate(page, res.value.id);
        }
        else {
          this.showModal('Atenção', res.message[0].message, null, 'ENTENDI');
        }
      });
  }

  updateProposal(currentStepNumber, statusId, status, id, idApolice) {

    var AlterProposalRequest = {
      statusId: statusId,
      currentStepNumber: currentStepNumber,
      status: status,
      id: id,
      idApolice: idApolice
    };

    this.propososalService
      .putProposalSearch(AlterProposalRequest)
      .subscribe((res) => {
      });
  }

  imprimirMinuta(event, id): void {
    const loadRef = this.dialog.open(LoadComponent, {
      panelClass: "custom-modalbox",
      disableClose: true,
    });

    this.proposalByCodeRequest = {
      cd_proposta: event.cd_proposta,
      cd_susep: event.cd_susep_corretor,
      id_usuario: event.id_usuario_corretor,
    };

    this.propososalService
      .getProposalByCode(this.proposalByCodeRequest)
      .subscribe((resI4Pro) => {
        this.ImprimirProposalRequest = {
          id_endosso: resI4Pro.value.Proposta_Pesquisar[0].id_endosso.toString(),
        };

        this.propososalService
          .getImprimirMinuta(this.ImprimirProposalRequest)
          .subscribe((res) => {
            this.convertToPDF(res.Proposta_ImprimirMinuta);

            loadRef.close();
          }, error => {
            loadRef.close();
          })
      });
  }

  emitirApolice(event, id) {
    const loadRef = this.dialog.open(LoadComponent, {
      panelClass: "custom-modalbox",
      disableClose: true,
    });


    this.proposalByCodeRequest = {
      cd_proposta: event.cd_proposta,
      cd_susep: event.cd_susep_corretor,
      id_usuario: event.id_usuario_corretor,
    };
    this.propososalService
      .getProposalByCode(this.proposalByCodeRequest)
      .subscribe((resI4Pro) => {
        this.EmitirApoliceProposalRequest = {
          tabela_proposta: this.setarTabelaProposta(event.id_proposta),
          id_apolice: resI4Pro.value.Proposta_Pesquisar[0].id_apolice,
          id_usuario: resI4Pro.value.Proposta_Pesquisar[0].cd_usuario_inclusao,
          id_endosso: resI4Pro.value.Proposta_Pesquisar[0].id_endosso,
          id_taker: event.id_pessoa_tomador,
          dv_assinatura_proposta: "true",
          dt_assinatura_proposta: new Date().toISOString().slice(0, 10),
          nm_observacao_assinatura:
            "Emissão de Apólice da proposta: " + resI4Pro.value.Proposta_Pesquisar[0].cd_proposta,
        };

        this.ImprimirProposalRequest = {
          id_endosso: resI4Pro.value.Proposta_Pesquisar[0].id_endosso.toString(),
        };

        this.propososalService
          .postEmitirApolice(this.EmitirApoliceProposalRequest)
          .subscribe((res) => {

            if (res.value != null) {
              if (res.value.cd_retorno == this.loadEnviromentsObj.requestCdRetorno.sucesso) {
                this.showModal(
                  "Apólice nº " +
                  res.value.nm_retorno.replace(/([^\d])+/gim, "") +
                  " emitida com sucesso!",
                  "A apólice estará disponível para consulta no sistema legado",
                  null,
                  "OK"
                );
                let idapolice = res.value.nm_retorno.replace(/([^\d])+/gim, "");

                const loadRef = this.dialog.open(LoadComponent, {
                  panelClass: "custom-modalbox",
                  disableClose: true,
                });

                this.propososalService
                  .getImprimirApolice(this.ImprimirProposalRequest)
                  .subscribe((res) => {
                    this.convertToPDF(res.Apolice_Imprimir);
                    this.router.navigate(["propostas/consultar"]);
                    loadRef.close();
                  }, error => {
                    loadRef.close();
                  })

                this.ProposalRequestByCodeI4pro = {
                  id_apolice: null,
                  cd_proposta: event.cd_proposta,
                  cd_susep: event.cd_susep_corretor.toString(),
                  id_pessoa_tomador: null,
                  id_pessoa_cliente: null,
                  cd_produto: null,
                  cd_status: null,
                  id_usuario: event.id_usuario_corretor,
                  data_inicial: null,
                  data_final: null,
                }

                this.propososalService.getProposalByCodeI4Pro(this.ProposalRequestByCodeI4pro)
                  .subscribe((ress) => {
                    this.updateProposal(4, 3, "Emitida", ress.data.value.id, ress.data.value.idApolice)
                  });

                loadRef.close();
              } else {
                this.showModal(
                  "Houve um erro ao emitir a apólice.",
                  res.value.cd_retorno != this.loadEnviromentsObj.requestCdRetorno.sucesso ? res.value.nm_retorno : res.message[0].message,
                  null,
                  "OK"
                );
                loadRef.close();
              }
            }
            else {
              this.showModal(
                "Atenção",
                res.message[0].message,
                null,
                "OK"
              );
              loadRef.close();
            }

          });

      });
  }

  imprimirApolice(event, id) {
    const loadRef = this.dialog.open(LoadComponent, {
      panelClass: "custom-modalbox",
      disableClose: true,
    });


    this.proposalByCodeRequest = {
      cd_proposta: event.cd_proposta,
      cd_susep: event.cd_susep_corretor,
      id_usuario: event.id_usuario_corretor,
    };

    this.propososalService
      .getProposalByCode(this.proposalByCodeRequest)
      .subscribe((resI4Pro) => {
        this.ImprimirProposalRequest = {
          id_endosso: resI4Pro.value.Proposta_Pesquisar[0].id_endosso.toString(),
        };

        this.propososalService
          .getImprimirApolice(this.ImprimirProposalRequest)
          .subscribe((res) => {
            this.convertToPDF(res.Apolice_Imprimir);

            loadRef.close();
          }, error => {
            loadRef.close();
          })
      });

  }

  convertToPDF(b64Data) {
    var link = document.createElement("a");
    link.innerHTML = "Download PDF file";
    link.download = "Impressao.pdf";
    link.href = "data:application/octet-stream;base64," + b64Data;
    link.click();
  }

  emitValue(data: any, type: any): void {
    this.eventButton.emit({ payload: data, type: type })
  }

  actionButton(data: any): void {
    this.eventButton.emit({ id: data });
  }

  secondActionButton(data: any): void {
    this.secondEventButton.emit({ id: data });
  }

  showModal(title: string, text: string, firstNameButton: string, secondNameButton: string) {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: { title, text },
      height: '238px',
      width: '480px'
    });
    dialogRef.componentInstance.firstNameButton = firstNameButton;
    dialogRef.componentInstance.secondNameButton = secondNameButton;
  }


  checkActionProposalPermission(action: string, type: string, status: string): boolean {
    if (type === 'Não cadastrada!') {
      return false;
    } else {
      let result = false;
      const filterTypeProposal = this.profileClaimResponse.filter(x => x.description === type);

      if (status === 'Em negociação') {
        // AÇÃO: Emitir  Apólice, REGRA: Verificar se usuario tem funcionalidade: Cadastrar ou Editar
        // AÇÃO: Imprimir Minuta REGRA: Verificar se usuario tem funcionalidade: Visualizar ou Cadastrar ou Editar
        if (action === 'Emitir Apólice') {
          const emitirApolice = filterTypeProposal
            .filter(x => x.actions.includes('post') === true || x.actions.includes('put') === true);

          result = emitirApolice.length > 0 ? true : false;
        } else if (action === 'Imprimir Minuta') {
          const imprimirMinuta = filterTypeProposal
            .filter(x => x.actions.includes('post') === true
              || x.actions.includes('put') === true
              || x.actions.includes('read') === true);

          result = imprimirMinuta.length > 0 ? true : false;
        }
      } else if (status === 'Emitida') {
        // AÇÃO: Imprimir Apólice REGRA: Verificar se usuario tem funcionalidade: Visualizar ou Cadastrar ou Editar
        if (action === 'Imprimir Apólice') {
          const imprimirApolice = filterTypeProposal
            .filter(x => x.actions.includes('post') === true
              || x.actions.includes('put') === true
              || x.actions.includes('read') === true);

          result = imprimirApolice.length > 0 ? true : false;
        }
      } else if (status === 'Em Análise') {
        if (action === 'Editar') {
          const editarProposta = filterTypeProposal
            .filter(x => x.actions.includes('put') === true);

          result = editarProposta.length > 0 ? true : false;
        }
      }
      return result;
    }
  }

  inativarParametroClausulas(item){
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        title: "Atenção",
        text:
          "Ao inativar o parâmetro não será possível reativá-lo! Deseja prosseguir?",
      },
      height: "238px",
      width: "480px",
      disableClose: true,
    });
    dialogRef.componentInstance.firstNameButton = "SIM";
    dialogRef.componentInstance.secondNameButton = "NÃO";
    dialogRef.componentInstance.eventFirstButton.subscribe((res) => {
      const loadRef = this.dialog.open(LoadComponent, {
        panelClass: 'custom-modalbox',
        disableClose: true
      });
      let request = {id: item.id};

      this.clauseService
      .disable(request)
      .subscribe((res) => {

        if(res.sucess){
          item.status = false;
          let date = new Date();
          let month = date.getMonth() + 1;
          let mes = null;
          if(month.toString().length == 1){
            mes = "0" + (date.getMonth() + 1);
          }
          item.finish = date.getDate() + "/" + (mes != null ? mes : month) + "/" + date.getFullYear();
        }
        else{
          this.showModal('Atenção', 'Ocorreu um problema de conexão, tente novamente!', null, 'ENTENDI');
        }

        loadRef.close();
      });
    });
  }

  inativarParametroLiberacaoPropostaTomador(item){
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        title: "Atenção",
        text:
          "Ao inativar o parâmetro não será possível reativá-lo! Deseja prosseguir?",
      },
      height: "238px",
      width: "480px",
      disableClose: true,
    });
    dialogRef.componentInstance.firstNameButton = "SIM";
    dialogRef.componentInstance.secondNameButton = "NÃO";
    dialogRef.componentInstance.eventFirstButton.subscribe((res) => {
      const loadRef = this.dialog.open(LoadComponent, {
        panelClass: 'custom-modalbox',
        disableClose: true
      });
      let request = {id: item.id};

      this.liberacaoPropostaTomadorService
      .disable(request)
      .subscribe((res) => {

        if(res.success){
          item.status = false;
          let date = new Date();
          let month = date.getMonth() + 1;
          let mes = null;
          if(month.toString().length == 1){
            mes = "0" + (date.getMonth() + 1);
          }
          item.finish = date.getDate() + "/" + (mes != null ? mes : month) + "/" + date.getFullYear();
        }
        else{
          this.showModal('Atenção', 'Ocorreu um problema de conexão, tente novamente!', null, 'ENTENDI');
        }

        loadRef.close();
      });
    });
  }

  inativarParametroTaxaMix(item){
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        title: "Atenção",
        text:
          "Ao inativar o parâmetro não será possível reativá-lo! Deseja prosseguir?",
      },
      height: "238px",
      width: "480px",
      disableClose: true,
    });
    dialogRef.componentInstance.firstNameButton = "SIM";
    dialogRef.componentInstance.secondNameButton = "NÃO";
    dialogRef.componentInstance.eventFirstButton.subscribe((res) => {
      const loadRef = this.dialog.open(LoadComponent, {
        panelClass: 'custom-modalbox',
        disableClose: true
      });
      let request = {id: item.id};

      this.averageMixService
      .disable(request)
      .subscribe((res) => {

        if(res.sucess){
          item.status = false;
          let date = new Date();
          let month = date.getMonth() + 1;
          let mes = null;
          if(month.toString().length == 1){
            mes = "0" + (date.getMonth() + 1);
          }
          item.endTerm = date.getDate() + "/" + (mes != null ? mes : month) + "/" + date.getFullYear();
        }
        else{
          this.showModal('Atenção', 'Ocorreu um problema de conexão, tente novamente!', null, 'ENTENDI');
        }

        loadRef.close();
      });
    });
  }

  isProposalTypeJudicial(proposalType) {
    const is = proposalType == 'Judicial Cível' || proposalType == 'Judicial Trabalhista' || proposalType == 'Judicial Fiscal'
    return is
  }

  setarTabelaProposta(id_proposta): number {
    switch (id_proposta) {
      case TipoDePropostaEnum.Licitacoes:
      case TipoDePropostaEnum.Contratos:
      case TipoDePropostaEnum.Recursal:
      case TipoDePropostaEnum.SME:
        return TabelaPropostaEnum.Proposta;
      case TipoDePropostaEnum.Civel:
      case TipoDePropostaEnum.Trabalhista:
      case TipoDePropostaEnum.Fiscal:
        return TabelaPropostaEnum.PropostaJudicial;

      case TipoDePropostaEnum.Adiantamento:
        return TabelaPropostaEnum.PropostaAdiantamento;
    }
  }
}
